<template>
    <div :class="field.Class" class="Field__Component">
        <div v-html="value" class="html-content"></div>
    </div>
</template>

<script>
export default {
    name: 'FieldHtml',
    props: ['value', 'field'],
};
</script>

<style scoped>
/* Use ::v-deep to penetrate scoped styles and apply to v-html content */
::v-deep .html-content {
    /* Base styles for HTML content */
    line-height: normal;
    font-size: 15px;
    white-space: normal;
}

::v-deep .html-content p {
    margin-block-start: 0;
    margin-block-end: 0;
}

/* Indent classes for RTL text */
::v-deep .html-content p.indent-1 {
    margin-right: 20px !important;
}

::v-deep .html-content p.indent-2 {
    margin-right: 40px !important;
}

::v-deep .html-content p.indent-3 {
    margin-right: 60px !important;
}

::v-deep .html-content p.indent-4 {
    margin-right: 80px !important;
}

::v-deep .html-content p.indent-5 {
    margin-right: 100px !important;
}
</style>
